import { inject } from "mobx-react";
import type { ILegalStores } from "./AppLegal";

type IStoresToProps<TStores, TProps extends object> = (stores: TStores) => TProps;

export function injectFromAppLegal<TProps extends object>(fn: IStoresToProps<ILegalStores, Partial<TProps>>) {
    return inject(fn);
}
